import { render, staticRenderFns } from "./LocalizationPanel.vue?vue&type=template&id=38e0752e&scoped=true&"
import script from "./LocalizationPanel.vue?vue&type=script&lang=ts&"
export * from "./LocalizationPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e0752e",
  null
  
)

export default component.exports